<template>
	<div class="wrapper">
		<v-container text-xs-center grid-list-sm>
			<v-layout justify-center row wrap>
				<v-flex xs12 sm12 md5>
					<v-text-field
						persistent-hint
						hint="Enter Text to Filter by"
						color="yellow darken-3"
						label="Filter Text"
						v-model="filterText"
					></v-text-field>
				</v-flex>
			</v-layout>
		</v-container>
		<v-container text-xs-center grid-list-sm>
			<v-layout justify-center row wrap>
				<v-flex xs6 sm6 md3>
					<v-btn @click="filterStockist" flat color="orange darken-1" large
						>Filter</v-btn
					>
				</v-flex>
				<v-flex xs6 sm6 md3 @click="refreshStockistList">
					<v-btn color="pink" flat>Reset Filter</v-btn>
				</v-flex>
			</v-layout>
		</v-container>
		<v-expansion-panel>
			<v-expansion-panel-content
				v-for="(item, index) of Object.keys(stockistMeta)"
				:key="item"
			>
				<template v-slot:header>
					<div class="font-weight-light pa-2">
						<span class="headline"
							>{{ index + 1 }}. Stockist Name: -
							{{
								stockistMeta[item][0] ? stockistMeta[item][0].name : ''
							}}</span
						>
						<br />
						<span class="subheader">Stockist Code: - {{ item }}</span>
						<br />
						<span class="subheader"
							>Metas: - {{ stockistMeta[item].length }}</span
						>
					</div>
				</template>
				<v-card flat>
					<v-card-text>
						<v-list two-line subheader>
							<v-list-tile
								v-for="(meta, index) in stockistMeta[item]"
								:key="meta._id"
								@click="openFileMetaModal(meta)"
							>
								<v-list-tile-action>
									<v-icon>attach_file</v-icon>
								</v-list-tile-action>
								<v-list-tile-content>
									<v-list-tile-title
										>{{ index + 1 }}. MetaId: -
										{{ meta._id }}</v-list-tile-title
									>
									<!-- <v-list-tile-sub-title>Extension: - {{meta.extension}}</v-list-tile-sub-title> -->
								</v-list-tile-content>
								<v-list-tile-action>
									<v-icon>keyboard_arrow_right</v-icon>
								</v-list-tile-action>
							</v-list-tile>
						</v-list>
					</v-card-text>
				</v-card>
			</v-expansion-panel-content>
		</v-expansion-panel>
		<div class="mt-1 mb-1 text-xs-center">
			<v-pagination
				color="yellow darken-3"
				prev-icon="navigate_before"
				next-icon="navigate_next"
				v-model="page"
				:total-visible="5"
				:length="paginationLength"
				@input="updatePage"
			></v-pagination>
		</div>
		<v-menu offset-y top>
			<template v-slot:activator="{ on }">
				<v-btn id="test" small fab bottom right color="primary" dark v-on="on">
					<v-icon>cloud_upload</v-icon>
				</v-btn>
			</template>
			<v-list>
				<v-list-tile @click="$refs.file.click()">
					<!-- application/vnd.ms-excel,  -->
					<input
						accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
						type="file"
						ref="file"
						style="display: none"
						@change="loadExcelFile"
					/>
					<v-list-tile-title>Upload file</v-list-tile-title>
				</v-list-tile>
				<v-list-tile @click="downloadStockistMappingErrors">
					<v-list-tile-title>Stockist Mapping Errors</v-list-tile-title>
				</v-list-tile>
				<v-list-tile @click="downloadCorrectedStockistMappingErrors">
					<v-list-tile-title>Corrected Mapping Errors</v-list-tile-title>
				</v-list-tile>
			</v-list>
		</v-menu>
		<FileMetaModal v-if="fileMetaEditorDialog" />
	</div>
</template>

<script>
import XLSX from 'xlsx';
import FileMetaModal from './fileMetaModal';
import { mapGetters, mapActions, mapMutations } from 'vuex';
export default {
	data() {
		return {
			page: 1,
			paginationLength: 10,
			filterText: '',
			forcedMappingHeaders: ['uuid', 'REMARK', 'CUST_CODE'],
			wrongMappingHeaders: ['uuid', 'REMARK', 'CORRECT_CODE', 'WRONG_CODE'],
		};
	},
	components: {
		FileMetaModal,
	},
	created() {
		this.fetchFileMeta();
	},
	methods: {
		...mapActions('stockist', [
			'getStockistMeta',
			'correctMapping',
			'forcedMapping',
			'downloadStockistMappingErrors',
			'downloadCorrectedStockistMappingErrors',
		]),
		...mapMutations('stockist', [
			'openFileMetaDialog',
			'setSelectedStockistMeta',
		]),
		...mapMutations(['openSnackbar', 'openLoaderDialog', 'closeLoaderDialog']),
		openFileMetaModal(item) {
			this.setSelectedStockistMeta(item);
			this.openFileMetaDialog();
		},
		fetchFileMeta() {
			let pageSize = 40;
			this.openLoaderDialog();
			this.getStockistMeta({
				pageNo: this.page,
				pageSize: pageSize,
				text: this.filterText,
			}).then(data => {
				this.closeLoaderDialog();
				if (data) {
					this.paginationLength = Math.ceil((data.length || 40) / pageSize);
					console.log('Loaded Stockist Meta');
				} else {
					console.log('Failed to load Stockist Meta');
				}
			});
		},
		refreshStockistList() {
			this.page = 1;
			this.filterText = '';
			this.fetchFileMeta();
		},
		updatePage() {
			this.fetchFileMeta();
		},
		filterStockist() {
			this.fetchFileMeta();
		},
		loadExcelFile(ev) {
			const file = ev.target.files[0];
			const reader = new FileReader();

			reader.readAsArrayBuffer(file);

			reader.onload = e => {
				var wb = XLSX.read(new Uint8Array(reader.result), {
					type: 'array',
				});
				var json = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);
				let headers = json.reduce((acc, cv) => {
					acc = Object.assign(acc, Object.keys(cv));
					return acc;
				}, []);

				let found = true;
				let fileType = '';
				for (let head of this.forcedMappingHeaders) {
					if (!headers.includes(head)) {
						found = false;
						break;
					}
				}
				if (found) {
					fileType = 'forceMapping';
				} else {
					found = true;
					for (let head of this.wrongMappingHeaders) {
						if (!headers.includes(head)) {
							found = false;
							break;
						}
					}
					if (found) fileType = 'wrongMapping';
				}

				switch (fileType) {
					case 'forceMapping': {
						this.openLoaderDialog();
						this.forcedMapping(this.createFormData(file)).then(data => {
							this.closeLoaderDialog();
							if (data.ok) {
								this.openSnackbar({
									text: data.message,
								});
							} else {
								this.openSnackbar({
									text: data.message,
								});
							}
						});
						break;
					}
					case 'wrongMapping': {
						this.openLoaderDialog();
						this.correctMapping(this.createFormData(file)).then(data => {
							this.closeLoaderDialog();
							if (data.ok) {
								this.openSnackbar({
									text: data.message,
								});
							} else {
								this.openSnackbar({
									text: data.message,
								});
							}
						});
						break;
					}
					default: {
						this.openSnackbar({
							text: 'Missing Headers in file',
						});
					}
				}
			};
		},
		createFormData(file) {
			let formData = new FormData();
			formData.append('MAPPING', file);
			return formData;
		},
	},
	computed: {
		...mapGetters(['getSelectedDates', 'selectedDates']),
		...mapGetters('stockist', ['fileMetaEditorDialog', 'stockistMeta']),
	},
	mounted() {
		this.$store.subscribe(mutation => {
			if (mutation.type === 'stockist/refreshStockistListEmitter') {
				this.refreshStockistList();
			}
		});
	},
	watch: {},
};
</script>

<style lang="scss" scoped>
.v-pagination >>> li button {
	width: 100%;
	min-width: 35px;
}
.v-card__text {
	padding: 0px;
}

#test {
	position: fixed;
}
</style>
